<template>
  <div v-if="landing" class="content_wrapper">
    <HeroBanner :title="landing.hero.header" :tagline="landing.hero.text" :button="landing.hero.button" />
    <DisplayVideo />

    <FeaturesListing :header="landing.benefitsHeader" :benefits="landing.benefits" />
    <MoreFeaturesListing />

    <BottomCTA :header="landing.bottom.header" :button="landing.bottom.button" />
  </div>
</template>

<script>
import HeroBanner from '@/components/main_page/HeroBanner.vue'
import DisplayVideo from '@/components/main_page/DisplayVideo.vue'
import BottomCTA from '@/components/main_page/BottomCTA.vue'
import FeaturesListing from '@/components/main_page/FeaturesListing.vue'
import MoreFeaturesListing from '@/components/main_page/MoreFeaturesListing.vue'
export default {
  name: 'PageContent',
  components: {
    HeroBanner,
    DisplayVideo,
    BottomCTA,
    FeaturesListing,
    MoreFeaturesListing,
  },
  props: {},
  data() {
    return {
      path: undefined,
      landing: undefined,
      componentKey: 0,
    }
  },

  async created() {
    let name = this.$route.path.replaceAll('/', '')
    this.path = name

    if (name != undefined) {
      let res = await fetch('/landings/' + name + '.json').catch('{}')
      const json = await res.json()

      this.landing = json
    }
  },
}
</script>

<style lang="scss" scoped></style>
